import React from 'react'
import Chat from "./Chat"

function Reporting() {
  return (
    <div>
      <Chat/>
    </div>
  )
}

export default Reporting
